module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-left-e3aa4351.svg";